

































































































































































































































































































































import {
  apiOrderOrderCancel,
  apiOrderOrderConfirm,
  apiOrderOrderDetail,
  apiOrderOrderPackageInfo,
  apiOrderOrderPay,
  apiOrderOrderQueryLogistics,
  apiOrderOrderUrged,
} from '@/api'
import {
  computed,
  nextTick,
  onMounted,
  ref,
  watch,
} from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import {
  defineClassComponent,
  useApi,
  useLoaded,
  useNewRoute,
  useQuery,
} from '@/hooks'
import { defineTvListeners } from '../utils'
import { navigateTo } from '@/router'
import { prepareData, requiredDeep, submit, Track } from '@/utils'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          // 埋点页面名称
          page: 'TV-订单详情',
        }))

        useLoaded(this.loading, () => this.goToActions(0))

        useNewRoute(this.showConfirmDialog)

        useNewRoute(this.showInfoDialog)

        useNewRoute(this.showExpressDialog)

        watch(
          () => this.showConfirmDialog.value,
          () => {
            if (this.showConfirmDialog.value) {
              nextTick(() => {
                ctx.$tv.setLimitingEl((ctx.$refs.confirmDialog as any).$el)
                this.goToConfirmActions(1)
              })
            } else {
              nextTick(() => {
                ctx.$tv.resetLimitingEl()
              })
            }
          },
        )

        watch(
          () => this.showInfoDialog.value,
          () => {
            if (this.showInfoDialog.value) {
              nextTick(() => {
                ctx.$tv.setLimitingEl((ctx.$refs.infoDialog as any).$el)
              })
            } else {
              nextTick(() => {
                ctx.$tv.resetLimitingEl()
              })
            }
          },
        )

        watch(
          () => this.showExpressDialog.value,
          () => {
            if (this.showExpressDialog.value) {
              nextTick(() => {
                ctx.$tv.setLimitingEl((ctx.$refs.expressDialog as any).$el)
              })
            } else {
              nextTick(() => {
                ctx.$tv.resetLimitingEl()
              })
            }
          },
        )

        onMounted(() => {
          if (this.query.showExpress) {
            this.viewExpressInfo()
          }
        })
      }

      query = useQuery<{
        // 订单编号
        orderNo: string
        // 是否显示物流信息
        showExpress?: boolean
      }>()

      // 加载状态
      loading = computed(() => this.apiData.loading)

      // 是否显示确认收货弹窗
      showConfirmDialog = ref(false)

      // 是否显示订单信息弹窗
      showInfoDialog = ref(false)

      // 是否显示物流信息弹窗
      showExpressDialog = ref(false)

      // 物流索引
      expressIndex = ref(0)

      apiData = useApi(() =>
        prepareData({
          orderData: apiOrderOrderDetail({
            orderNo: this.query.orderNo,
          }).then(requiredDeep),
        }),
      )

      orderData = computed(() => this.apiData.data.orderData)

      expressData = ref<any[]>([])

      handleCountdownEnd = () => {
        this.apiData.refresh()
      }

      // 查看物流信息
      viewExpressInfo = () => {
        submit(async $ => {
          $.start()
          const packages = await apiOrderOrderPackageInfo(
            {
              orderNo: this.query.orderNo,
            },
            {
              noErrorToast: true,
            },
          )
            .then(requiredDeep)
            .then(res => res.items)
          this.expressData.value = await Promise.all(
            packages.map(async pkg => {
              // @ts-ignore
              pkg.expressData = await apiOrderOrderQueryLogistics({
                orderNo: this.query.orderNo,
                packageId: pkg.packageId,
              })
              return pkg
            }),
          )
          this.showExpressDialog.value = true
        })
      }

      // 跳到操作
      goToActions = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.actions as any, index)
      }

      // 跳到商品
      goToGoods = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.goods as any, index)
      }

      // 跳到确认收货操作
      goToConfirmActions = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.confirmActions as any, index)
      }

      // 操作监听器
      actionsListeners = defineTvListeners(({ type, isLast, el }) => {
        switch (type) {
          case 'right':
            if (isLast) {
              this.goToGoods(0)
            }
            break
          case 'click':
            const action:
              | '支付'
              | '取消订单'
              | '确定收货'
              | '查看物流'
              | '提醒发货'
              | '订单信息'
              | '售后' = el.textContent!.trim() as any
            switch (action) {
              case '支付':
                submit(async $ => {
                  await $.start()
                  const payData = await apiOrderOrderPay({
                    orderNo: this.query.orderNo,
                  })
                  await dcb.requestPayment({
                    provider: 'native',
                    showNativeResultPage: false,
                    params: payData,
                  })
                  await this.apiData.refresh()
                  await $.success('支付成功')
                })
                break
              case '取消订单':
                submit(async $ => {
                  $.start()
                  await apiOrderOrderCancel({
                    orderNo: this.query.orderNo,
                  })
                  await this.apiData.refresh()
                  await $.success('取消订单成功')
                })
                break
              case '提醒发货':
                submit(async $ => {
                  $.start()
                  await apiOrderOrderUrged({
                    orderNo: this.query.orderNo,
                  })
                  await this.apiData.refresh()
                  await $.success('我们已提醒商家加急为您发货')
                })
                break
              case '确定收货':
                this.showConfirmDialog.value = true
                break
              case '订单信息':
                this.showInfoDialog.value = true
                break
              case '查看物流':
                this.viewExpressInfo()
                break
              case '售后':
                navigateTo('TvAfterSalesRequest', {
                  orderNo: this.query.orderNo,
                })
                break
              default:
                break
            }
            break
          default:
            break
        }
      })

      // 商品监听器
      goodsListeners = defineTvListeners(({ type, index }) => {
        switch (type) {
          case 'click':
            if (index === 0) {
              navigateTo('TvMartIndex', {
                id: this.orderData.value.merchantId,
              })
            } else {
              navigateTo('TvGoodsIndex', {
                id: this.orderData.value.commodities[index - 1].commodityId,
              })
            }
            break
          default:
            break
        }
      })

      // 确认收货操作监听器
      confirmActionsListeners = defineTvListeners(({ type, index }) => {
        switch (type) {
          case 'click':
            if (index === 0) {
              this.showConfirmDialog.value = false
            } else {
              submit(async $ => {
                $.start()
                await apiOrderOrderConfirm({
                  orderNo: this.query.orderNo,
                })
                await this.apiData.refresh()
                await $.success('确认收货成功')
                this.showConfirmDialog.value = false
              })
            }
            break
          default:
            break
        }
      })

      // 物流监听器
      expressListeners = defineTvListeners(({ type, index }) => {
        switch (type) {
          case 'focus':
            this.expressIndex.value = index
            break
          case 'up':
            ctx.$tv.scrollUp(ctx.$refs.expressDialog)
            break
          case 'down':
            ctx.$tv.scrollDown(ctx.$refs.expressDialog)
            break
          default:
            break
        }
      })
    },
)
